module.exports = __webpack_public_path__ + "img/img-706039.jpg";